<template>
  <SectionSplit03
    :title="t('title')"
    :description="t('description')"
    :thumbnail="thumbnail"
    :button01="button01"
    :button02="button02"
    @click-button="handleClickButton"
  />
</template>

<script setup lang="ts">
  import type { IButton } from '@/components/Shared/Section/Split/03.vue';

  const { t, locale } = useI18n({ useScope: 'local' });
  const { blobDomain } = useWebsite();
  const { provideResponsiveImgName } = useImagePath();

  const profileStore = useProfileStore();
  const { isLogin } = storeToRefs(profileStore);

  const thumbnail = computed(
    (): string =>
      `${blobDomain.value}/wise-paas-marketplace/topics2/doe/${provideResponsiveImgName('resources')}`
  );

  const button01 = computed(
    (): IButton => ({
      text: t('item-1-button'),
      // ponytail: contact-sales 頁面尚未建立，banner 的按鈕也須更改連結
      link: `/${locale.value}/marketplace/topics/digital-om-energy/contact-sales`,
    })
  );

  const button02 = computed((): IButton | undefined =>
    isLogin.value
      ? undefined
      : { text: t('item-2-button'), link: 'javascript:void(0)' }
  );

  const handleClickButton = (index: number): void => {
    if (index === 1) {
      profileStore.HANDLE_LOGIN();
    }
  };
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Start Your Digital O&M Journey!",
    "description": "Find the right starting point with expert guidance and free access to practical resources that help accelerate your O&M transformation.",
    "item-1-button": "Talk to an Expert",
    "item-2-button": "Get Free Resources"
  },
  "en-jp": {
    "title": "Start Your Digital O&M Journey!",
    "description": "Find the right starting point with expert guidance and free access to practical resources that help accelerate your O&M transformation.",
    "item-1-button": "Talk to an Expert",
    "item-2-button": "Get Free Resources"
  },
  "en-tw": {
    "title": "Start Your Digital O&M Journey!",
    "description": "Find the right starting point with expert guidance and free access to practical resources that help accelerate your O&M transformation.",
    "item-1-button": "Talk to an Expert",
    "item-2-button": "Get Free Resources"
  },
  "en-kr": {
    "title": "Start Your Digital O&M Journey!",
    "description": "Find the right starting point with expert guidance and free access to practical resources that help accelerate your O&M transformation.",
    "item-1-button": "Talk to an Expert",
    "item-2-button": "Get Free Resources"
  },
  "en-americas": {
    "title": "Start Your Digital O&M Journey!",
    "description": "Find the right starting point with expert guidance and free access to practical resources that help accelerate your O&M transformation.",
    "item-1-button": "Talk to an Expert",
    "item-2-button": "Get Free Resources"
  },
  "en-asia-pacific": {
    "title": "Start Your Digital O&M Journey!",
    "description": "Find the right starting point with expert guidance and free access to practical resources that help accelerate your O&M transformation.",
    "item-1-button": "Talk to an Expert",
    "item-2-button": "Get Free Resources"
  },
  "en-emea": {
    "title": "Start Your Digital O&M Journey!",
    "description": "Find the right starting point with expert guidance and free access to practical resources that help accelerate your O&M transformation.",
    "item-1-button": "Talk to an Expert",
    "item-2-button": "Get Free Resources"
  },
  "ja-jp": {
    "title": "デジタル維持管理を始める",
    "description": "今すぐ専門家へのご相談と無料リソースを活用し、自社に適したO&M変革の第一歩を見つけ、次のステップへ進みましょう。",
    "item-1-button": "専門家に相談",
    "item-2-button": "無料リソースを見る"
  },
  "zh-tw": {
    "title": "啟動數位維運旅程",
    "description": "現在就透過專業諮詢與免費資源，找到適合您的 O&M 轉型切入點，加速推動轉型落地。",
    "item-1-button": "諮詢專家",
    "item-2-button": "取得免費資源"
  }
}
</i18n>
